
import React,{useEffect,useState,useRef,useCallback} from 'react'
import {Link} from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import _ from 'lodash'
import { BASE_URL2 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import {IMG_URL2 } from '../Config/Base';
import loader from '../Assets/Images/Loading_icon.gif'

// import { ClipLoader,PulseLoader,FadeLoader} from 'react-spinners';



const pageSize =15;
const  FoundSectionEIMain=()=>{

  const[file1,setFile1]= useState();
  const[file2,setFile2]= useState();
  const [display, setDisplay] =useState(true)
  const[edit,setEdit]= useState(true)
  const[del,setDel]= useState(true)
  const[pop,setpop] = useState(false);
  // const [paginatedPosts, setpaginatedPosts] = useState();
  // const [currentPage, setcurrentPage] = useState(1);
  const [Event, setEvent] = useState([])

    const handleFileChange = (e) => {
    
        setFile1(e.target.files[0]);
    
    };
    const handleFileChange1 = (e) => {
    
        setFile2(e.target.files[0]);
    
    };
  function AddAddress(){

      var EI = document.getElementById('eventid').value
      var Cap = document.getElementById('eventcaption').value


      if(!EI){

        document.getElementById("EventIdErr").innerHTML="This Field is Required";
      
      }
  
       else if(EI){
        document.getElementById("EventIdErr").innerHTML=" ";
  
       }
  
       if(!Cap){
  
        document.getElementById("EventCaptionErr").innerHTML="This Field is Required";
  
      }
      else if(Cap){
  
        document.getElementById("EventCaptionErr").innerHTML=" ";
  
      }


      if(!file1){
    
        document.getElementById("EventImage_PathErr").innerHTML="This Field is Required";
  
      }
      else if(file1){
  
        document.getElementById("EventImage_PathErr").innerHTML=" ";
  
      }

      // if(!file2){
  
      //   document.getElementById("EventFileNameErr").innerHTML="This Field is Required";
  
      // }
      // else if(file2){
  
      //   document.getElementById("EventFileNameErr").innerHTML=" ";
  
      // }
  
          
     if(EI&&Cap&&file1)
     {
       
       const body={
         
         event_name:EI,
        //  image_path:file1,
         del_status:0,
         caption:Cap,
         fileName:file1
        
     
         }
     
         console.log('body',body);
          
         axios({
           
             method: "POST",
             url:`${BASE_URL}/FoundationMain/AddGalleries`,
             data: body,
             headers: {
               "Content-Type" : "multipart/form-data"
                
             }
     
         })
       
         .then((response) =>{
           console.log(response.data);
     
           if(response.data.message === "Galleries Added Successfully!"){
     
            alert("Add Successfully !");
              //toast.success("Content Added Successfully !");
              getGalleries();
              setFile1();
              setFile2();
              // GetAddressDWH();
              document.getElementById('addressform-clear').reset();
       
            }
         
            
         })
     
     .catch(error => {
       console.log(error);
       alert("Failed to Add !");
      //toast.warning("Added failed !")
      
     })

    }
       
  }



       const token = JSON.parse(localStorage.getItem('usertoken'));
         const [Galleries, setGalleries] = useState([])
     
         const pageSize = 3;

         const [paginatedPosts, setpaginatedPosts] = useState();
       
        useEffect(()=>{
         
          setpop(true);
          getGalleries();
          getEvent()
          getRoleData();
          getRole();
          document.getElementById('section-main').style.display = "none";

          setTimeout(()=>{
          setpop(false);
          getUserRole();
          document.getElementById('section-main').style.display = "block";
        
          },1000)

        }, [])
      

        function getEvent() {


          fetch(`${BASE_URL}/FoundationMain/GetEvent`, {
      
            method: 'GET',
      
            headers: {
      
              "Content-type": "application/json",
      
              "Accept": "application/json",
      
              // "Authorization": "Bearer " + `${token}`,
      
              "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      
            },
      
            //body:JSON.stringify(data)
      
          }).then(response => response.json())
      
            .then(data => {
              console.log("Data", data)
              setEvent(data);
              setpaginatedPosts(_(data).slice(0).take(pageSize).value());
              localStorage.setItem("paginationDataEvents", JSON.stringify(data));  
            }
            );
      
          console.log("check", Event)
        }
      

          function getGalleries(){
      
      
            //console.log("Token", token)
          fetch(`${BASE_URL}/FoundationMain/GetGalleries`, {
        
            method: 'GET',
        
            headers: {
        
              "Content-type": "application/json",
        
              "Accept": "application/json",
        
              //"Authorization": "Bearer " + `${token}`,
        
              "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        
            },
        
            //body:JSON.stringify(data)
        
          }).then(response => response.json())
        
            .then(data => {
              console.log("Data", data)
              setGalleries(data)
               setpaginatedPosts(_(data).slice(0).take(pageSize).value());
              localStorage.setItem("paginationDataGalleries", JSON.stringify(data));    
                }
            );


            
        
        console.log("check",Galleries)
          }
                 


        //   const pageCount = Galleries? Math.ceil(Galleries.length/pageSize) :0;
        //     // if (pageCount === 1)
        //    // return null;

        //   const pages = _.range(1, pageCount+1)

        //   const pagination =(pageNo)=>{

        //   // if (pageCount === 1)
        //   // return null;
        //   setcurrentPage(pageNo);
        //     const startIndex = (pageNo - 1) * pageSize;
        //    const paginatedPost = _(Galleries).slice(startIndex).take(pageSize).value();
        //    setpaginatedPosts(paginatedPost)
        //  }


          function ConfirmDelete(Id){

            SelectGalleries(Id);
            document.getElementById("modalDeleteForm").style.display = "block";
            document.getElementById("DisplayEditPop").style.display = "none";
          }

           
    function Canceldel() {
      document.getElementById("modalDeleteForm").style.display = "none";      
        }
        
    
         function closedelForm()
         {
            document.getElementById("modalDeleteForm").style.display = "none";
          
          }


//  delete status //

          function GalleriesDeleteStatus(Id){
            const token = JSON.parse(localStorage.getItem('usertoken'));
        
            // var ans=window.confirm('Are you sure want to delete this Section?');
            // if(ans==true)
            // {
              const body ={
             id: Id
           }
            console.log('check',body)
             axios({
            
             method:"POST",
            url:`${BASE_URL}/FoundationMain/GalleriesDeleteStatus`,
            data:body,
            headers: {
            "Content-Type" : "application/json",
            "Authorization": "Bearer " +`${token}`
          
            }
           
             })
             .then((response) =>{
             console.log(response.data);
             alert("Delete Successfully !");
             closedelForm();
              setTimeout(() => {
                
                getGalleries();
               

              }, 1000);
            
          
            })
            
            .catch(error => {
              console.log(error);
              alert("Failed to Delete !")
            // toast.warning("Failed to Delete")   
            })
            
            // }

             
            
              }   



/*----Get select to the particular Id----*/
const [EditGalleries ,SetEditGalleries] =useState([]);

function SelectGalleries(Id){

  
  setFileA();
  setFileB();
  document.getElementById("DisplayEditPop").style.display = "block";

  const token = JSON.parse(localStorage.getItem('usertoken'));

   const body =
    {
      
      id: Id
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/FoundationMain/SelectGallery`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " +`${token}` 
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
     
          SetEditGalleries(response.data);
     
       })
       .catch(error => {
         console.log(error);
         
       })

 }

 function closeForm(){

  // setpop(true);
  // document.getElementById('section-main').style.display = "none";
  document.getElementById('DisplayEditPop').style.display="none";
  document.getElementById('foundationEditform').reset();

  document.getElementById("GalleryErrB").innerHTML=" ";
  document.getElementById("GalleryErrC").innerHTML=" ";
  // setTimeout(()=>{
  //   document.getElementById('section-main').style.display = "block";
  //   setpop(false);   
  // },1000)
 }


 /*----EditSection----*/


 const[fileA,setFileA]= useState();
  const[fileB,setFileB]= useState();

    const handleFileChangeA= (e) => {

      setFileA(e.target.files[0]);
      setFileB(e.target.value)

      console.log(fileB,"wertj")
      document.getElementById("foundchangeinput").reset()
      // setTimeout(() => {
      //   setFileB( )
      // }, 1000);
    };
    const handleFileChangeB = (e) => {
    
        setFileB(e.target.files[0]);
    
    };

// function handleImage(){

  
//   if(!fileA){

//     document.getElementById("GalleryErrA").innerHTML="Image Required";
//    }

//    else if(fileA){
//     document.getElementById("GalleryErrA").innerHTML=" ";

//    }

//    if(!fileB){

//     document.getElementById("GalleryErrC").innerHTML="Image Required";

//   }
//   else if(fileB){

//     document.getElementById("GalleryErrC").innerHTML=" ";

//   }

// }

function updateGalleries(Id){

  const token = JSON.parse(localStorage.getItem('usertoken'));

  var Caption = document.getElementById('EVLoc').value
  var Event = document.getElementById('ENEdit').value
  var OldImage=document.getElementById('oldGalleryFound').value
  
    // if(!fileA){

    //   document.getElementById("GalleryErrA").innerHTML="Image Required";
    //  }

    //  else if(fileA){
    //   document.getElementById("GalleryErrA").innerHTML=" ";

    //  }

     if(!Caption){

      document.getElementById("GalleryErrB").innerHTML="Caption Required";

    }
    else if(Caption){

      document.getElementById("GalleryErrB").innerHTML=" ";

    }
    if(!Event){

      document.getElementById("GalleryErrC").innerHTML="Event Required";

    }
    else if(Event){

      document.getElementById("GalleryErrC").innerHTML=" ";

    }
    // if(!fileB){

    //   document.getElementById("GalleryErrC").innerHTML="Image Required";

    // }
    // else if(fileB){

    //   document.getElementById("GalleryErrC").innerHTML=" ";

    // }

if(Caption && Event){
    

const body ={
    
     Id:Id,
     fileName:fileA,
     caption:Caption,
    //  fileName:fileB,
     event_name:Event,
     oldimage:OldImage
   }
   console.log(body);


     axios({
   
       method: "POST",
       
       url:`${BASE_URL}/FoundationMain/EditGallery`,
       data:body,
       headers: {
         
        'Content-Type': 'multipart/form-data'   
          
        
       }
     
     })
    
     .then((response) =>{
       console.log(response.data);
       if(response.data.status === "Error"){
    
               alert("InCorrect")
             }
         
             else if(response.data.message === "Gallery Updated Successfully!"){
              alert("Upload Successfully!")
              setFileA();
              setFileB();
               getGalleries()
               document.getElementById('DisplayEditPop').style.display="none";
                 setTimeout(() => {
                 
                  closeForm()

                 }, 2000);
               }
              
        })

      .catch(error => {
       console.log(error);
        alert("Failed to Upload !")       
        })
     }
    }
    

    function getRoleData(){
     
      
      let UserRole =  localStorage.getItem("Role");
     
      const body ={
       
       roles:UserRole
     
      }
      console.log(body);
     
      const token = JSON.parse(localStorage.getItem('usertoken'));
     
       axios({          
          method: "POST", 
          url:`${BASE_URL}/Foundation/GetUserLoginRoles`,      
          data:body,
          headers:{             
            'Content-Type': 'application/json' , 
            "Authorization": "Bearer " + `${token}`     
          }
        
        })
        .then((response) =>{
         console.log(response.data);
         localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
         
          }) 
        
         }
 
 
         function getRole(){
     
           const token = JSON.parse(localStorage.getItem('usertoken'));
     
           fetch(`${BASE_URL}/Foundation/FoundationGetRoles`, {
             method:'GET',
       
           headers : {
       
             "Content-type": "application/json",
       
             "Accept": "application/json",
       
             "Authorization": "Bearer " +`${token}`,
       
             "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
           },
       
       
       })
       
                 .then(response => response.json())
       
       
                   .then(data => {
                    console.log("Role",data)
                   //  setRoletable(data)
                     localStorage.setItem("Data", JSON.stringify(data));
                   });
           }



           function getUserRole(){
  
            /**----getroleAction---- */
        let Tcrole =  localStorage.getItem("loginUserRoleaction");
        let roledata =  JSON.parse(Tcrole);
        let role = roledata.map((e)=>e.roleAction);
        console.log(role);
        
        let roles = role.toString();
        let add = roles.includes('Add')
        console.log(add)
        
        let view = roles.includes('View')
        console.log(view)
        
        let edit = roles.includes('Edit')
        console.log(edit)
        
        let del= roles.includes('Delete')
        console.log(del)
        
        /**-----get UserRole--- */
        
        let allroles =   localStorage.getItem("Data")
        let roledataA =  JSON.parse(allroles);
        //console.log(roledataA)
        let allrole = roledataA.map((e)=>e.roles);
        console.log(allrole);
         let rolestr = allrole.toString();
        console.log(rolestr)
        
        let userrole = localStorage.getItem("Role");
        console.log(userrole)
        
         let userroleResult = rolestr.includes(userrole)
        console.log(userroleResult)
        
  
        let empty = roles.includes('')
        console.log(empty)
    
    
        let roleid = localStorage.getItem('RoleId')
        let id = roleid.includes('01')
        console.log(id)
    
    
        if(id==true&&empty==true&&add==false&&view==false&&edit==false&&del==false)
        {
          setDisplay(true);
          setEdit(true);
          setDel(true);
        
        }
        if(id==false&&empty==true&&add==false&&view==false&&edit==false&&del==false)
        {
          setDisplay(false);
          setEdit(false);
          setDel(false);
          document.getElementById('Foundsectiontable').style.display ="none";
          document.getElementById('Add-section-btn').style.display ="none";
          document.getElementById('eventid').style.display ="none";
          document.getElementById('eventcaption').style.display ="none";
          document.getElementById('filechoose-input').style.display ="none";
          document.getElementById('Foundaction-err').innerHTML = 'Not Assign'
          document.getElementById('Foundaction-err').style.color = "red"
          document.getElementById('Foundaction-err').style.fontWeight = "bold"
          document.getElementById('Foundaction-err').style.alignItems = "center"
          document.getElementById('Foundaction-err').style. justifyContent = "center"
          document.getElementById('Foundaction-err').style. display= "flex"
          document.getElementById('foundnavpag').style. display= "none"
    
          
        }
    
            
            if( view==true){
              setDisplay(false);
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('eventid').style.display ="none";
              document.getElementById('eventcaption').style.display ="none";
              document.getElementById('filechoose-input').style.display ="none";
               
            }
            if(add==true){
              setDisplay(false);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('eventid').style.display ="block";
              document.getElementById('eventcaption').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block";
               
            }
            if(edit==true){
              setDisplay(true);
              setEdit(true)
              setDel(false)
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('eventid').style.display ="none";
              document.getElementById('eventcaption').style.display ="none";
              document.getElementById('filechoose-input').style.display ="none";
               
            }

            if(del==true){
              setDisplay(true);
              setEdit(false)
              setDel(true)
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('eventid').style.display ="none";
              document.getElementById('eventcaption').style.display ="none";
              document.getElementById('filechoose-input').style.display ="none";
               
            }

            if(add==true&& view==true&& edit==true&& del==true)
            {
              setDisplay(true);
              setEdit(true);
              setDel(true);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('eventid').style.display ="block";
              document.getElementById('eventcaption').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block";
               
            }

            if(edit==true&&del==true)
            {
              setDisplay(true);
              setEdit(true);
              setDel(true);
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('eventid').style.display ="none";
              document.getElementById('eventcaption').style.display ="none";
              document.getElementById('filechoose-input').style.display ="none";
            }

            
            if(add==true&& edit==true)
          {
              setDisplay(true);
              setEdit(true);
              setDel(false);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('eventid').style.display ="block";
              document.getElementById('eventcaption').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block";
            }

            if(add==true&& del==true)
            {
                setDisplay(true);
                setEdit(false);
                setDel(true);
                document.getElementById('Add-section-btn').style.display ="block";
                document.getElementById('eventid').style.display ="block";
                document.getElementById('eventcaption').style.display ="block";
                document.getElementById('filechoose-input').style.display ="block";
              }

            if(add==true&& edit==true&& del==true)
          {
              setDisplay(true);
              setEdit(true);
              setDel(true);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('eventid').style.display ="block";
              document.getElementById('eventcaption').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block";
            }
            

          } 


          
    const LEFT_PAGE = "LEFT";
    const RIGHT_PAGE = "RIGHT";
    const range = (from, to, step = 1) => {
      let i = from;
      const range = [];
    
      while (i <= to) {
        range.push(i);
        i += step;
      }
    
      return range;
    };
     const [currentPage, setCurrentPage] = useState(1);

    let data = localStorage.getItem("paginationDataGalleries")
    let transdata =  JSON.parse(data);
    let NUM_OF_RECORDS = transdata.length;
    let LIMIT = 5;
    
    const onPageChanged = useCallback(
    
      (event, page) => {
        event.preventDefault();
        setCurrentPage(page);
      },
      [setCurrentPage]
      
    );
    
    
    const currentData = transdata.slice(
      (currentPage - 1) * LIMIT,
      (currentPage - 1) * LIMIT + LIMIT
    );
    
    const Paginations = (props) => {
      const {
        totalRecords,
        pageLimit,
        pageNeighbours,
        onPageChanged,
        currentPage
      } = props;
      const [totalPages, setTotalPages] = useState(0);
      useEffect(() => {
        setTotalPages(Math.ceil(totalRecords / pageLimit));
      }, [setTotalPages]);
    
      const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 1 + 0;
        console.log(totalNumbers)
        console.log(pageNeighbours)
        const totalBlocks = totalNumbers + 2;
        console.log(totalBlocks)
    
        if (totalPages > totalBlocks) {
          const startPage = Math.max(2, currentPage - pageNeighbours);
          const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    
          let pages = range(startPage, endPage);
    
          const hasLeftSpill = startPage > 2;
          const hasRightSpill = totalPages - endPage > 1;
          const spillOffset = totalNumbers - (pages.length + 1);
    
          switch (true) {
            case hasLeftSpill && !hasRightSpill: {
              const extraPages = range(startPage - spillOffset, startPage - 1);
              pages = [LEFT_PAGE, ...extraPages, ...pages];
              break;
            }
            case hasLeftSpill && hasRightSpill:
            default: {
              pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
              break;
            }
          }
          return [1, ...pages, totalPages];
        }
        return range(1, totalPages);
      };
    
    
      const pages = fetchPageNumbers() || [];
      return (
        <nav aria-label="Countries Pagination" id='foundnavpag'>
          <ul className="pagination">
            {pages.map((page, index) => {
              if (page === LEFT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      href="/"
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                );
    
              if (page === RIGHT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      className="page-link"
                      href="/"
                      aria-label="Next"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 1)}
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                );
    
              return (
                <li
                  key={index}
                  className={`page-item${currentPage === page ? " active" : ""}`}
                >
                  <a
                    className="page-link"
                    href="/"
                    onClick={(e) => onPageChanged(e, page)}
                  >
                    {page}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    };

  return(
    
    <div className='foundation-addmain'>

    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundSectionJS'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Event Galleries</span>
    </div>
    </div>
    
    <span id="Foundaction-err"></span>

    {pop?<div className='text-center'><img src={loader} alt="loader" id='loading-Indicator'/></div>
        :null}

    <div id='section-main'>
<div className='foundation-EItable-section'>
{/* <div className="table_foundation-responsive "> */}


<form id='addressform-clear' onSubmit={AddAddress}>
<div className="modal-body mx-4">

<div className='text-center'>
{/* <h5>Contents</h5> */}
</div>

<br></br>

<div className='col-sm-12'>

<div className='row'> 

<div className='col-sm-5'> 
<div className="md-form mb-0">
<select  name="eventname"  className="form-select"  id='eventid'>
<option value="">Event Name</option>
{Event.map((e) => {
      return <option value={e.eventName}>{e.eventName}</option>})}
</select>
{/* <input type="text" id='eventid' maxLength={4} placeholder='Event Name'/> */}


<span id="EventIdErr" className='error'></span>
</div>
</div>


<div className='col-sm-5'> 
<div className="md-form mb-0">
<input type="file"  placeholder='FileName' onChange={handleFileChange} id='filechoose-input'/>
<span id="EventImage_PathErr" className='error'></span>
</div>
</div>


<div className='col-sm-5'> 
<div className="md-form mb-0">
<input type="text" id='eventcaption' placeholder='Caption'/>
<span id="EventCaptionErr" className='error'></span>
</div>
</div>


{/* <div className='col-sm-5'> 
<div className="md-form mb-0">
<input type="file"  placeholder='fileName' onChange={handleFileChange1} id='filechoose-input'/>
<span id="EventFileNameErr" className='error'></span>
</div>
</div> */}

<div className='col-sm-2'> 
<div className="md-form mt-2">
<button className='foundation-Assign-button' id='Add-section-btn' type='submit'>ADD</button>
</div>
</div>

</div>
</div>
</div>



{/* <div className='d-flex justify-content-center' style={{marginRight:"120px"}}>
<button className='foundation-Assign-button' id='Add-section-btn' type='submit'>ADD</button>
</div> */}

</form>



{/* </div> */}
</div>

<br></br>

<div className='foundationContent-table'>
<div className="table_foundationContent-responsive " id="Foundsectiontable">

{/* <div className='text-center'>
<h5>Event Images</h5>
</div> */}
{/* {
  !paginatedPosts ? ("No data found"):( */}

    <table>
      <thead>
        <tr>
          <th>Event Name</th>
          {/* <th>Image_Path</th> */}
          <th>Caption</th>
          <th>FileName</th>
          {display?<th>Action</th>:null}
        </tr>
      </thead>
    <tbody>

    {currentData.map((e) => {
      return <tr>
        <td>{e.eventName}</td>
        {/* <td>{e.image_path}</td> */}
        <td>{e.caption}</td>
        {/* <td>{e.fileName}</td> */}
        <td><img style={{width:"55px",height:"55px"}} src={e.fileName}/></td>
        {display?<td className='text-center'>
        {edit? <span><i class="fa fa-pencil" aria-hidden="true"onClick={()=>SelectGalleries(e.id)}   id="FoundEditicon"></i></span>:null} &nbsp;&nbsp;
            {del?  <span><i class="fa fa-trash" aria-hidden="true"onClick={()=>ConfirmDelete(e.id)} id="FoundDelicon" ></i></span>:null}
            </td>:null}

      </tr>

    })}
     
    </tbody>
 
   
    </table>
  
  {/* )} */}
 
  <br></br>
  

</div>
</div>
<br></br>

{transdata.length<=5? null:<div>{

!paginatedPosts ? (""):(

          <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={1}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          /> 

          )}
          </div>
}

  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}

  {/* DeletePopup */}

  <div className="foundation-pop-fade" id="modalDeleteForm" tabindex="-1" role="dialog">
 {EditGalleries.map((e)=>{ 
   return<div className="modal-dialog" role="document">
      <div className="modal-content"  style={{marginTop:"280px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to delete this Content?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="foundation-adduser-button"  onClick={()=>GalleriesDeleteStatus(e.id)} type='submit'>Delete</button>
        <button className="foundation-adduser-button"  onClick={Canceldel} type='submit'>Cancel</button>
       </div>
       </form>
      
     </div>
    </div>
    })} 
</div>
 
 {/* EditPopup */}

<div className='foundation-pop-fade' id="DisplayEditPop">
{EditGalleries.map((e)=>{
   return<div className="modal-dialog"  role="document">
    <div className="modal-content"  style={{marginTop:"180px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="foundationEditform" onSubmit={()=>updateGalleries(e.id)}>
      <div className="modal-body mx-3">

         

        <div className="md-form mb-4">
        <label>File Name</label> 

         {!fileA?
         <div><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChangeA}/>
         <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
         <input defaultValue={e.fileName}  id="oldGalleryFound"style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
          <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
          {/* &nbsp;<span >{e.fileName}</span> */}
          </div>
         </div>:
          <div><form id="foundchangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChangeA}/>
          <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px",borderRadius:"2px",marginTop:"-50px",color:"red"}}>
          <input defaultValue={fileB}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
           <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
        
           </div></form> <input defaultValue={e.fileName} id="oldGalleryFound" style={{display:"none"}} /></div>}
         
         
         <span id="GalleryErrA" className='error'></span>
        </div>

        <div className="md-form mb-4">
        <label>Caption</label> 
         <input type="text" id="EVLoc" defaultValue={e.caption} />
         <span id="GalleryErrB" className='errorsection'></span>
        </div>

        <div className="md-form ">
        <label>Event Name</label> 
         <input type="text" id="ENEdit" defaultValue={e.event_name}/>
         <span id="GalleryErrC" className='error'></span>
        </div>

        

      </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className='foundation-profile-button' type="submit">Update</button>
      </div>
      </form>
      
    </div>
  </div>
})}

</div>


</div>
</div>

   
  )
}

export default FoundSectionEIMain